import React, { useState } from 'react';
import './ResponsibilityForm.css';

const ResponsibilityForm = ({ roleId, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    responsibilityName: '',
    definition: '',
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!formData.responsibilityName || !formData.responsibilityName.trim()) {
      newErrors.responsibilityName = 'Responsibility name is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }

    onSave({
      responsibilityName: formData.responsibilityName.trim(),
      definition: formData.definition.trim() || null,
      roleId: roleId,
      isUniversal: false,
    });
  };

  return (
    <form className="responsibility-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="responsibilityName" className="form-label">
          Responsibility Name <span className="required">*</span>
        </label>
        <input
          id="responsibilityName"
          type="text"
          className={`form-input ${errors.responsibilityName ? 'error' : ''}`}
          value={formData.responsibilityName}
          onChange={(e) => handleInputChange('responsibilityName', e.target.value)}
          placeholder="e.g., Product Strategy"
        />
        {errors.responsibilityName && (
          <span className="error-message">{errors.responsibilityName}</span>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="definition" className="form-label">
          Definition
        </label>
        <textarea
          id="definition"
          className="form-textarea"
          value={formData.definition}
          onChange={(e) => handleInputChange('definition', e.target.value)}
          placeholder="Enter a description for this responsibility..."
          rows={3}
        />
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="cancel-button"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="submit-button"
        >
          Add Responsibility
        </button>
      </div>
    </form>
  );
};

export default ResponsibilityForm;
